import { useRating } from '@risksmart-app/components/src/hooks/useRating';
import { useMemo } from 'react';

import { UNRATED } from '../../../../controls/lookupData';
import type {
  ComplianceDocumentAssessmentResultFlatFields,
  ComplianceDocumentAssessmentResultRegisterFields,
} from './types';

export const useOversightDocumentRatingLabelledFields = (
  records: ComplianceDocumentAssessmentResultFlatFields[] | undefined
) => {
  const { getByValue: getResultByValue } = useRating(
    'performance_result',
    'oversight'
  );

  return useMemo<ComplianceDocumentAssessmentResultRegisterFields[]>(() => {
    return (
      records?.map((d) => {
        const assessment = d.parents.filter((a) => a.oversightAssessment)[0]
          ?.oversightAssessment;

        return {
          ...d,
          Title: assessment?.Title ?? '-',
          ActualCompletionDate: assessment?.ActualCompletionDate ?? '-',
          CompletionDate: assessment?.ActualCompletionDate ?? '-',
          ResultValue: d.Rating ?? UNRATED.value,
          TestDate: d.TestDate ?? null,
          Result: getResultByValue(d.Rating)?.label ?? UNRATED.label,
          Id: d.Id,
          OversightAssessmentId: assessment?.Id,
          Status: assessment?.Status ?? '-',
          NextTestDate: assessment?.NextTestDate,
        };
      }) || []
    );
  }, [records, getResultByValue]);
};
